import moment from "moment";
import Vue from "vue";
import FnBReportsService from "@/services/FnBReportsService";
import ReportsService from "@/services/ReportsService";
import { router } from "@/router";
import _ from "lodash";
import store from "@/store";

function initialState() {
  return {
    DailyPerishableMovementPdfFilename: null,
    DailyPerishableMovementExcelFilename: null,
    RecipeReportsExcelFileName: null,
    RecipeReportsPDFFileName: null,
    COGSReportsExcelFileName: null,
    COGSReportsPDFFileName: null,
    CurrentStockReportsExcelFileName: null,
    CurrentStockReportsPDFFileName: null,
    StockWastageReportsExcelFileName: null,
    StockWastageItemReportData: null,
    StockWastageReportsPDFFileName: null,
    ItemWastageReportsPDFFileName: null,
    ItemWastageReportsExcelFileName: null,
    dropDownObject: {
      fromDate: new Date(),
      cinema_name: null,
      cinema_id: null,
      wd_day: null,
      wd_id: null,
      rmc_id: null,
      rmc_category: null,
      fromDate: new Date(),
      endDate: new Date(),
      startTime: null,
      endTime: null,
      searchWord: null,
      cinema_address:null,
    },
    Chart: {
      fromDate: new Date(),
      endDate: new Date(),
    },
    RecipeReports: [],
    FastMovingReports: [],
    DailyPerishableMovement: [],
    perishableDates: [],
    FastMovingReportsTotal: {
      qtySold: 0,
      net_amount: 0,
      std_profit: 0,
      std_profit_percentage: 0,
      cost_price: 0
    },
    CurrentStockReports: [],
    COGSReportData: [],
    AllCOGSReportData: [],
    NonReccoRecords: [],
    StockWastageReportData: [],
    pdfrecord: "",
    excelrecord: "",
    order: "asc"
  };
}

const state = initialState();

const mutations = {
  SET_CHART_DATES: (state, payload) => {
    console.log("payload :", payload);
    payload["name"]
      ? (state.Chart[payload.name] = payload["event"] ? payload.event : null)
      : "";
    console.log("state.Chart[payload.name] :", state.Chart[payload.name]);
  },
  SET_FAST_MOVING_PDF: (state, response) => {
    state.pdfrecord = response.FinalPDFFile;
    state.excelrecord = response.FinalExcelFile;
  },
  SET_RECIPE_REPORTS_EXCEL_FILE_NAME: (state, payload) => {
    state.RecipeReportsExcelFileName = payload;
  },
  SET_RECIPE_REPORTS_PDF_FILE_NAME: (state, payload) => {
    state.RecipeReportsPDFFileName = payload;
  },
  SET_COGS_REPORTS_EXCEL_FILE_NAME: (state, payload) => {
    state.COGSReportsExcelFileName = payload;
  },
  SET_COGS_REPORTS_PDF_FILE_NAME: (state, payload) => {
    state.COGSReportsPDFFileName = payload;
  },
  SET_CURRENT_STOCK_REPORTS_EXCEL_FILE_NAME: (state, payload) => {
    state.CurrentStockReportsExcelFileName = payload;
  },
  SET_CURRENT_STOCK_REPORTS_PDF_FILE_NAME: (state, payload) => {
    state.CurrentStockReportsPDFFileName = payload;
  },
  SET_STOCK_WASTAGE_EXCEL_FILE_NAME: (state, payload) => {
    state.StockWastageReportsExcelFileName = payload;
  },
  SET_STOCK_WASTAGE_PDF_FILE_NAME: (state, payload) => {
    state.StockWastageReportsPDFFileName = payload;
  },
  SET_ITEM_WASTAGE_PDF_FILE_NAME: (state, payload) => {
    state.ItemWastageReportsPDFFileName = payload;
  },
  SET_ITEM_WASTAGE_EXCEL_FILE_NAME: (state, payload) => {
    state.ItemWastageReportsExcelFileName = payload;
  },
  SET_DROP_DOWN_VALUES: (state, payload) => {
    // console.log('payload.name :', payload.name);
    switch (payload.name) {
      case "isCinema":
        state.dropDownObject.cinema_id = payload["selectedItem"]
          ? payload.selectedItem.cine_id
          : null;
        state.dropDownObject.cinema_name = payload["selectedItem"]
          ? payload.selectedItem.cine_name
          : null;
          state.dropDownObject.cinema_address = payload["selectedItem"]
          ? payload.selectedItem.cine_address
          : null;
        break;
      case "isDays":
        state.dropDownObject.wd_id = payload["selectedItem"]
          ? payload.selectedItem.wd_id
          : null;
        state.dropDownObject.wd_day = payload["selectedItem"]
          ? payload.selectedItem.wd_day
          : null;
        break;
      case "isRawMaterialCategory":
        state.dropDownObject.rmc_id = payload["selectedItem"]
          ? payload.selectedItem.rmc_id
          : null;
        state.dropDownObject.rmc_category = payload["selectedItem"]
          ? payload.selectedItem.rmc_category
          : null;
        break;
      case "fromDate":
        state.dropDownObject.fromDate =
          payload.name == "fromDate" && payload["event"]
            ? payload["event"]
            : null;
        break;
      case "endDate":
        state.dropDownObject.endDate =
          payload.name == "endDate" && payload["event"]
            ? payload["event"]
            : null;
        break;
      case "startTime":
        state.dropDownObject.startTime = payload["event"]
          ? moment(payload["event"]).format("HH:mm")
          : null;
        break;
      case "endTime":
        state.dropDownObject.endTime = payload["event"]
          ? moment(payload["event"]).format("HH:mm")
          : null;
        break;
      case "searchWord":
        state.dropDownObject.searchWord = payload["event"]
          ? payload["event"]
          : "";
        break;
      default:
        console.log("Recipe Report :( Sorry, we are enable to set value.");
    }
  },
  SET_RECIPE_REPORTS_DATA: (state, payload) => {
    state.RecipeReports = _.chain(payload)
      .groupBy("item_id")
      .toPairs()
      .map(function(currentItem) {
        return _.fromPairs(_.zip(["item_id", "ItemsList"], currentItem));
      })
      .value();
    console.log(state.RecipeReports, "RecipeReportData");
  },
  SET_FAST_MOVING_REPORTS_DATA: async (state, payload) => {
    state.FastMovingReports = payload.Records || [];
    state.FastMovingReportsTotal = payload.FastMovingReportsTotal;
  },
  SET_CURRENT_STOCK_REPORT_DATA: (state, payload) => {
    state.CurrentStockReports = payload || [];
  },
  SET_DAILY_PERISHABLE_MOVEMENT: async (state, payload) => {
    state.DailyPerishableMovement = payload.Records || [];
    state.perishableDates = payload.dates;
    state.DailyPerishableMovementExcelFilename = payload.FinalExcelFile;
    state.DailyPerishableMovementPdfFilename = payload.FinalPDFFile;
  },
  RESET_FASTMOVING_DATA: (state, payload) => {
    state.FastMovingReports = [];
    state.FastMovingReportsTotal = {
      qtySold: 0,
      net_amount: 0,
      std_profit: 0,
      std_profit_percentage: 0,
      cost_price: 0
    };
  },
  SET_COGS_REPORT_DATA: (state, payload) => {
    state.COGSReportData = payload.Records || [];
    console.log(state.COGSReportData, "state.COGSReportData");
    state.AllCOGSReportData = payload.AllRecords || [];
    state.NonReccoRecords = payload.NonReccoRecords || [];
  },
  SORT_ORDER: (state, payload) => {
    switch (payload.name) {
      case "net_price":
        if (payload.type == "asc") {
          state.FastMovingReports = state.FastMovingReports.sort(function(
            a,
            b
          ) {
            return a.sum_net_amount - b.sum_net_amount;
          });
          state.order = "asc";
        } else if (payload.type == "desc") {
          state.order = "desc";
          state.FastMovingReports = state.FastMovingReports.sort(function(
            a,
            b
          ) {
            return b.sum_net_amount - a.sum_net_amount;
          });
        }
      case "std_profit%":
        if (payload.type == "asc") {
          state.FastMovingReports = state.FastMovingReports.sort(function(
            a,
            b
          ) {
            return a.std_profit_percentage - b.std_profit_percentage;
          });
          state.order = "asc";
        } else if (payload.type == "desc") {
          state.order = "desc";
          state.FastMovingReports = state.FastMovingReports.sort(function(
            a,
            b
          ) {
            return b.std_profit_percentage - a.std_profit_percentage;
          });
        }
    }
  },
  SET_STOCK_WASTAGE_REPORT: (state, payload) => {
    state.StockWastageReportData = payload.Records || [];
    state.StockWastageItemReportData = payload.hasOwnProperty('ItemWastageRecordsLogs') && payload.ItemWastageRecordsLogs ? payload.ItemWastageRecordsLogs : [];
  },
  SET_FNB_DATE_FILTER: (state, payload) => {
    if (payload == "Day") {
      state.Chart.fromDate = moment().valueOf();
      state.Chart.endDate = moment().valueOf();
      store.dispatch("fetchFnbAnalyticsChart");
    }
    if (payload == "Week") {
      state.Chart.fromDate = moment()
        .subtract(1, "w")
        .valueOf();
      state.Chart.endDate = moment().valueOf();
      store.dispatch("fetchFnbAnalyticsChart");
    }
    if (payload == "Month") {
      state.Chart.fromDate = moment()
        .subtract(1, "M")
        .valueOf();
      state.Chart.endDate = moment().valueOf();
      store.dispatch("fetchFnbAnalyticsChart");
    }
  },
  SET_FnB_DROP_DOWN_CLEAR: (state, payload) => {
    state.Chart.fromDate = payload;
    state.Chart.endDate = payload;
  },
  RESET_DROP_DOWN_VALUES: (state, payload) => {
    state.dropDownObject = {
      fromDate: new Date(),
      cinema_name: null,
      cinema_id: null,
      wd_day: null,
      wd_id: null,
      rmc_id: null,
      rmc_category: null,
      fromDate: new Date(),
      endDate: new Date(),
      startTime: null,
      endTime: null,
      cinema_address:null,
    };
  }
};

const actions = {
  ResetDropDownValues: async ({ dispatch, commit, state }, payload) => {
    await commit("RESET_DROP_DOWN_VALUES");
  },
  ResetRecipeReport: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_RECIPE_REPORTS_DATA", []);
  },
  ResetFastMovingReport: async ({ dispatch, commit, state }, payload) => {
    await commit("RESET_FASTMOVING_DATA", []);
  },
  ResetCurrentStockReport: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_CURRENT_STOCK_REPORT_DATA", []);
  },
  ResetCOGSReport: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_COGS_REPORT_DATA", []);
  },
  ResetStockWastageReport: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_STOCK_WASTAGE_REPORT", []);
  },
  onRecipeReportDropDownHandler: async (
    { dispatch, commit, state },
    payload
  ) => {
    await commit("SET_DROP_DOWN_VALUES", payload);
  },
  onSortValue: async ({ dispatch, commit, state }, payload) => {
    await commit("SORT_ORDER", payload);
  },
  onCurrentStockDropDownHandler: async (
    { dispatch, commit, state },
    payload
  ) => {
    await commit("SET_DROP_DOWN_VALUES", payload);
  },
  onCOGSDropDownHandler: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_DROP_DOWN_VALUES", payload);
  },
  onStockWastageDropDownHandler: async (
    { dispatch, commit, state },
    payload
  ) => {
    await commit("SET_DROP_DOWN_VALUES", payload);
  },
  onPerishableReportDropDownHanlder: async (
    { dispatch, commit, state },
    payload
  ) => {
    await commit("SET_DROP_DOWN_VALUES", payload);
  },
  onFetchRecipeReports: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_RECIPE_REPORTS_DATA", []);
    let loader = Vue.$loading.show();
    await FnBReportsService.GetRecipeReports(state.dropDownObject)
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_RECIPE_REPORTS_DATA", data.Records);
          await commit(
            "SET_RECIPE_REPORTS_EXCEL_FILE_NAME",
            data["ExcelName"] || null
          );
          await commit(
            "SET_RECIPE_REPORTS_PDF_FILE_NAME",
            data["PDFName"] || null
          );
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(
          "Catch Error on FnBReportStore fetchRecipeReports",
          error
        );
      });
  },
  onFetchFastMovingReports: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_FAST_MOVING_REPORTS_DATA", []);
    let loader = Vue.$loading.show();
    await FnBReportsService.GetFastMovingReports(state.dropDownObject)
      .then(response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          let newPayload = {
            Records: data.Records,
            FastMovingReportsTotal: data.FastMovingReportsTotal
          };
          commit("SET_FAST_MOVING_REPORTS_DATA", newPayload);
          commit("SET_FAST_MOVING_PDF", data);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(
          "Catch Error on FnBReportStore fetchFastMovingReport",
          error
        );
      });
  },
  onFetchCurrentStockReport: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_CURRENT_STOCK_REPORT_DATA", []);
    let loader = Vue.$loading.show();
    await FnBReportsService.GetCurrentStockReport(state.dropDownObject)
      .then(async response => {
        console.log(state.dropDownObject);
        loader.hide();
        const { data } = response;
        if (data.status) {
          // let newPayload = {
          //     Records: data.Records,
          // }
          let tempRecords = data.Records;
          let sumVal = 0;
          let stockSumVal = 0;
          tempRecords.map(x => {
            x.RawMaterials.reduce((acc, { system_stock, single_rate }) => {
              let productVal = system_stock * single_rate;
              if (productVal > 0) {
                sumVal = acc + productVal;
              }
              return sumVal;
            }, 0);
            x.RawMaterials.reduce((acc, { system_stock }) => {
              if (system_stock > 0) {
                stockSumVal = acc + system_stock;
              }
              return stockSumVal;
            }, 0);
            x["GrandTotal"] = sumVal;
            x["SystemStockTotal"] = stockSumVal;
          });
          commit("SET_CURRENT_STOCK_REPORT_DATA", data.Records);
          await commit(
            "SET_CURRENT_STOCK_REPORTS_EXCEL_FILE_NAME",
            data["ExcelName"] || null
          );
          await commit(
            "SET_CURRENT_STOCK_REPORTS_PDF_FILE_NAME",
            data["PDFName"] || null
          );
          // commit('SET_FAST_MOVING_PDF', data)
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(
          "Catch Error on FnBReportStore fetchCurrentStockReport",
          error
        );
      });
  },
  onFetchCOGSReports: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_COGS_REPORT_DATA", []);
    let loader = Vue.$loading.show();
    state.dropDownObject["fromDate"] = moment(
      state.dropDownObject["fromDate"]
    ).format("YYYY-MM-DD");
    state.dropDownObject["endDate"] = moment(
      state.dropDownObject["endDate"]
    ).format("YYYY-MM-DD");

    await FnBReportsService.GetCOGSReport(state.dropDownObject)
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          await commit("SET_COGS_REPORT_DATA", data);
          await commit(
            "SET_COGS_REPORTS_EXCEL_FILE_NAME",
            data["ExcelName"] || null
          );
          await commit(
            "SET_COGS_REPORTS_PDF_FILE_NAME",
            data["PDFName"] || null
          );
          // commit('SET_FAST_MOVING_PDF', data)
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(
          "Catch Error on FnBReportStore fetchCOGSReports",
          error
        );
      });
  },
  onFetchStockWasteageReports: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_STOCK_WASTAGE_REPORT", []);
    let loader = Vue.$loading.show();
    await FnBReportsService.GetStockWastageReport(state.dropDownObject)
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          await commit("SET_STOCK_WASTAGE_REPORT", data);
          await commit(
            "SET_STOCK_WASTAGE_EXCEL_FILE_NAME",
            data["ExcelName"] || null
          );
          await commit(
            "SET_STOCK_WASTAGE_PDF_FILE_NAME",
            data["PDFName"] || null
          );
          await commit(
            "SET_ITEM_WASTAGE_PDF_FILE_NAME",
            data["ItemPDFName"] || null
          );
          await commit(
            "SET_ITEM_WASTAGE_EXCEL_FILE_NAME",
            data["ItemExcelName"] || null
          );
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(
          "Catch Error on FnBReportStore fetchCOGSReports",
          error
        );
      });
  },
  onFetchPerishableReportData: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_DAILY_PERISHABLE_MOVEMENT", []);
    let loader = Vue.$loading.show();
    await FnBReportsService.GetDailyPerishableMovement(state.dropDownObject)
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          await commit("SET_DAILY_PERISHABLE_MOVEMENT", data);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(
          "Catch Error on FnBReportStore fetchCOGSReports",
          error
        );
      });
  },

  fetchFnbAnalyticsChart: async ({ dispatch, commit, state }, payload) => {
    let loader = Vue.$loading.show();

    state.Chart["fromDate"] = moment(state.Chart["fromDate"]).format(
      "YYYY-MM-DD"
    );
    state.Chart["endDate"] = moment(state.Chart["endDate"]).format(
      "YYYY-MM-DD"
    );
    await FnBReportsService.GetFnbAnalyticsData(state.Chart)
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          if (data.Records.length > 0 && data.Data.length > 0) {
            let payload = {
              data1: data.Records,
              data2: data.Data,
              Dates: state.Chart,
              CategoryData: data.CategoryData
            };
            store.dispatch("onSetFnbAnalyticsChartData", payload);
          } else {
            Vue.toasted.show("No Data Found.");
          }
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        loader.hide();
        Vue.toasted.show("Catch Error on FnBReportStore", error);
      });
  },

  // On Handlers
  onChartDateHandler: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_CHART_DATES", payload);
  },

  OnSelectFNBFilter: async ({ dispatch, commit, state }, payload) => {
    commit("SET_FNB_DATE_FILTER", payload);
  },
  FnBClearDates: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_FnB_DROP_DOWN_CLEAR", payload);
  }
};

const getters = {
  getRecipeReportsSelectedCinema: state => state.dropDownObject.cinema_name,
  getCOGSSelectedCinema: state => state.dropDownObject.cinema_name,
  getStockWastageSelectedCinema: state => state.dropDownObject.cinema_name,
  getSelectedWeekDay: state => state.dropDownObject.wd_day,
  getCOGSSelectedRawMaterialCategory: state =>
    state.dropDownObject.rmc_category,
  getCOGSReportFromDate: state => state.dropDownObject.fromDate,
  getCOGSReportEndDate: state => state.dropDownObject.endDate,
  getStockWastageFromDate: state => state.dropDownObject.fromDate,
  getStockWastageToDate: state => state.dropDownObject.endDate,
  getStockWastageStartTime: state => state.dropDownObject.startTime,
  getStockWastageEndTime: state => state.dropDownObject.endTime,
  getRecipeReports: state => state.RecipeReports,
  getFastMovingReports: state => state.FastMovingReports,
  getFastMovingReportsTotal: state => state.FastMovingReportsTotal,
  getCurrentStockReports: state => state.CurrentStockReports,
  getCOGSReportData: state => state.COGSReportData,
  getAllCOGSReportData: state => state.AllCOGSReportData,
  getNonReccoRecords: state => state.NonReccoRecords,
  getStockWastageReport: state => state.StockWastageReportData,
  getStockWastageItemReport: state => state.StockWastageItemReportData,
  getDailyPerishableMovement: state => state.DailyPerishableMovement,
  getperishableDates: state => state.perishableDates,
  getPDFRecord: state => state.pdfrecord,
  getExcelRecord: state => state.excelrecord,
  getOrder: state => state.order,

  //Chart
  getFNBChartFromDate: state => state.Chart.fromDate,
  getFNBChartEndDate: state => state.Chart.endDate,

  // Get File name
  getRecipeReportsExcelFileName: state => state.RecipeReportsExcelFileName,
  getRecipeReportsPDFFileName: state => state.RecipeReportsPDFFileName,
  getCOGSReportsExcelFileName: state => state.COGSReportsExcelFileName,
  getCOGSReportsPDFFileName: state => state.COGSReportsPDFFileName,
  getCurrentStockReportsExcelFileName: state =>
    state.CurrentStockReportsExcelFileName,
  getCurrentStockReportsPDFFileName: state =>
    state.CurrentStockReportsPDFFileName,
  getStockWastageReportsExcelFileName: state =>
    state.StockWastageReportsExcelFileName,
  getStockWastageReportsPDFFileName: state =>
    state.StockWastageReportsPDFFileName,
  getItemWastageReportsPDFFileName: state => state.ItemWastageReportsPDFFileName,
  getItemWastageReportsExcelFileName: state => state.ItemWastageReportsExcelFileName,
  DailyPerishableMovementExcelFilename: state =>
    state.DailyPerishableMovementExcelFilename,
  DailyPerishableMovementPdfFilename: state =>
    state.DailyPerishableMovementPdfFilename
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/FnBReportStore.js